<template>
  <div>
    <div style="display:inline-flex">
      <el-select v-model="dis_province" filterable placeholder="请选择省份" @change="provinceChange">
        <el-option v-if="showAll" label="全国" :value="0"></el-option>
        <el-option
          v-for="(value,key) in dis_provinces"
          :key="key"
          :label="value.full_name"
          :value="value.id">
        </el-option>
      </el-select>

      <el-select style="margin-left:5px;" v-model="dis_city" filterable placeholder="请选择市区" @change="cityChange">
        <el-option v-if="dis_show_all_city" label="全省" :value="0"></el-option>
        <el-option
          v-for="(value,key) in dis_cities"
          :key="key"
          :label="value.full_name"
          :value="value.id">
        </el-option>
      </el-select>

      <el-select style="margin-left:5px;" v-if="dis_show_area" v-model="dis_area" filterable placeholder="请选择区域" @change="areaChange">
        <el-option v-if="dis_show_all_city" label="全市" :value="0"></el-option>
        <el-option
          v-for="(value,key) in dis_areas"
          :key="key"
          :label="value.full_name"
          :value="value.id">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
    import {getProvince, getCity, getArea} from "@/api/public"

    export default {
        props: {
            placeholder: {
                type: String,
                default: "请选择地区"
            },
            level: {
                type: Number,
                default: 3
            },
            value: {
                type: Array,
                default: () => []
            },
            showAll: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                pcaValue: [],
                dis_provinces: [],
                dis_cities: [],
                dis_areas: [],
                dis_province: '',
                dis_province_str: '全国',
                dis_city: '',
                dis_city_str: '',
                dis_area: '',
                dis_area_str: '',
                dis_show_area: false,
                dis_show_all_city: false,
                special_province: ['北京市','天津市','重庆市']
            }
        },
        mounted() {
            this.pcaValue = this.value
            getProvince().then(res=>{
                if (res.code === 200) this.dis_provinces = res.data
                this.$forceUpdate()
            })
            if(this.level === 3) this.dis_show_area = true
        },
        watch: {
            value: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    this.dis_province = newValue[0]
                    this.dis_provinces.forEach((value, key)=>{
                        if(value.id === newValue[0]){
                            this.dis_province_str = value.full_name
                            if(this.special_province.indexOf(value.full_name) > -1){
                                if(this.level === 2) this.dis_show_area = true
                                if(this.showAll) this.dis_show_all_city = false
                            }else{
                                if(this.level === 2) this.dis_show_area = false
                                if(this.showAll) this.dis_show_all_city = true
                            }
                            getCity(value.province_id).then(res=>{
                                if(res.code === 200) {
                                    this.dis_cities = res.data
                                    this.dis_city = newValue[1]
                                    res.data.forEach((v, k)=>{
                                        if(v.id === newValue[1]){
                                            this.dis_city_str = v.full_name
                                            getArea(v.city_id).then(res=>{
                                                if(res.code === 200) {
                                                    this.dis_areas = res.data
                                                    this.dis_area = newValue[2]
                                                    res.data.forEach((value, key)=>{
                                                        if(value.id === newValue[2]){
                                                            this.dis_area_str = value.full_name
                                                        }
                                                    })
                                                }
                                                this.$forceUpdate()
                                            })
                                        }
                                    })
                                }
                                this.$forceUpdate()
                            })
                            return ;
                        }
                    })
                }
            }
        },
        methods: {
            provinceChange(e){
                this.dis_city = ''
                this.dis_city_str = ''
                this.dis_area = ''
                this.dis_area_str = ''
                if(e === 0){
                    this.dis_province_str = '全国'
                    this.dis_cities = [];
                    this.dis_areas = [];
                    this.handlePCAChoose()
                }else{
                    this.dis_provinces.forEach((value, key)=>{
                        if(value.id === e){
                            this.dis_province_str = value.full_name
                            if(this.special_province.indexOf(value.full_name) > -1){
                                if(this.level === 2) this.dis_show_area = true
                                if(this.showAll) this.dis_show_all_city = false
                            }else{
                                if(this.level === 2) this.dis_show_area = false
                                if(this.showAll) this.dis_show_all_city = true
                            }
                            getCity(value.province_id).then(res=>{
                                if(res.code === 200) {
                                    this.dis_cities = res.data
                                }
                                this.$forceUpdate()
                            })
                            return ;
                        }
                    })
                }
            },
            cityChange(e){
                this.dis_area = ''
                this.dis_area_str = ''
                if(e === 0){
                    this.dis_city_str = '全省'
                    this.dis_areas = [];
                    this.handlePCAChoose()
                }else{
                    this.dis_cities.forEach((value, key)=>{
                        if(value.id === e){
                            this.dis_city_str = value.full_name
                            if(!this.dis_show_area) this.handlePCAChoose()
                            getArea(value.city_id).then(res=>{
                                if(res.code === 200) {
                                    this.dis_areas = res.data
                                }
                                this.$forceUpdate()
                            })
                            return ;
                        }
                    })
                }
            },
            areaChange(e){
                if(e === 0){
                    this.dis_city_str = '全市'
                    this.handlePCAChoose()
                }else{
                    this.dis_areas.forEach((value, key)=>{
                        if(value.id === e){
                            this.dis_area_str = value.full_name
                            this.handlePCAChoose()
                            return;
                        }
                    })
                }
            },
            handlePCAChoose() {
                this.$emit('choose', {
                    province_code: this.dis_province,
                    province: this.dis_province_str,
                    city_code: this.dis_city,
                    city: this.dis_city_str,
                    area_code: this.dis_area,
                    area: this.dis_area_str
                })
            }
        }
    }
</script>

<style scoped lang="scss">
  .districts-cascader {
    width: 100% !important;
  }
</style>
